'use strict'
import { date } from 'quasar'

export const OFFSET_MSK_MS = 3 * 60 * 60 * 1000

export const MONTHS = [
  'Январь',
  'Февраль',
  'Март',
  'Апрель',
  'Май',
  'Июнь',
  'Июль',
  'Август',
  'Сентябрь',
  'Октябрь',
  'Ноябрь',
  'Декабрь'
]

export function convertEmployeesFromMapToArray (employeesMap, workDays, currentEmployeeIds) {
  const rows = []

  let countWorkArea = 0
  for (const [workArea, workAreaEmployees] of employeesMap) {
    rows.push({ name: workArea, workArea: workArea, type: 'workArea', schedule: getDefaultScedule(workDays), stat: workAreaEmployees.stat, class: 'calendar-bg-work-area-' + countWorkArea % 2 })

    for (const [role, group] of Object.entries(workAreaEmployees.groups)) {
      if (group.employees.length) {
        rows.push({ key: role, name: getGroupName(role), type: 'role', stat: group.stat, class: 'calendar-bg-role-' + countWorkArea % 2, workArea: workArea })

        // Создаём copyEmployees для проставления orderInGroup и orderInGroupIncremental, не меняя порядка; находим максимальный order в группе
        let copyEmployees = []
        let maxOrderInGroup = 0
        group.employees.forEach((employee) => {
          if (employee.orderInGroup > maxOrderInGroup) {
            maxOrderInGroup = employee.orderInGroup
          }
          copyEmployees.push(employee)
        })

        // Сортируем copyEmployees по orderInGroup, сотрудники без orderInGroup в конец группы по ФИО
        copyEmployees.sort((a, b) => {
          if (a.orderInGroup && b.orderInGroup) {
            return a.orderInGroup - b.orderInGroup
          } else if (a.orderInGroup) {
            return -1
          } else if (b.orderInGroup) {
            return 1
          } else {
            return a.shortFIO.localeCompare(b.shortFIO)
          }
        })

        // Для мобильного интерфейса: текущего пользователя наверх группы
        if (currentEmployeeIds && currentEmployeeIds.length) {
          currentEmployeeIds.forEach((currentEmployeeId) => {
            const currentEmployee = copyEmployees.find(employee => currentEmployeeId === employee.id)
            copyEmployees = copyEmployees.filter(employee => currentEmployeeId !== employee.id)
            if (currentEmployee) {
              copyEmployees.unshift(currentEmployee)
            }
          })
        }

        // Сформировать orderInGroupIncremental для отображения и заполнить orderInGroup, у кого он null
        copyEmployees.forEach((employee, index) => {
          employee.orderInGroupIncremental = index + 1
          if (!employee.orderInGroup) {
            employee.orderInGroup = maxOrderInGroup + employee.orderInGroupIncremental
          }
        })

        // orderInGroup делаем уникальным: при совпадении увеличиваем на 1
        for (let i = 1; i < copyEmployees.length; i++) {
          if (copyEmployees[i].orderInGroup === copyEmployees[i - 1].orderInGroup) {
            copyEmployees[i].orderInGroup = copyEmployees[i - 1].orderInGroup + 1
          }
        }

        // Расположить в порядке как с сервера, а если нужно сортировать по order, то плюсом отсортировать
        group.employees.forEach((employee) => {
          employee.groupWorkArea = workArea
          employee.type = 'employee'
          employee.class = 'calendar-bg-employee-' + countWorkArea % 2
          rows.push(employee)
        })
      }
    }

    countWorkArea++
  }

  return rows
}

function getGroupName (role) {
  if (role === 'brigadeemployee') {
    return 'Полевые'
  } else if (role === 'office') {
    return 'Офис'
  } else if (role === 'another') {
    return 'Другие'
  }
}

export function convertEmployeesFromServerToMap (employees, workDays, availableWorkAreas) {
  // Только направления из общего фильтра + объединяем КТО и ФВФ
  const groupNameWorkAreas = []
  availableWorkAreas.forEach((availableWorkArea) => {
    if (availableWorkArea.name === 'КТО' || availableWorkArea.name === 'ФВФ') {
      if (!groupNameWorkAreas.includes('КТО ФВФ')) {
        groupNameWorkAreas.push('КТО ФВФ')
      }
    } else {
      groupNameWorkAreas.push(availableWorkArea.name)
    }
  })

  const employeesArray = convertEmployeesScheduleFromServer(employees, workDays)
  let employeesMap = new Map()

  workDays.forEach((day, indexDay) => {
    // Считаем на клиенте, чтобы согласовывалось с логикой в направлениях и ролях, и при изменении расписания обновлялось
    day.employeesCount = 0
  })

  // Объединение КТО и ФВФ (создаём convertedWorkArea и convertedOrder из workArea и order соответственно)
  employeesArray.forEach((employee) => {
    const convertedWorkArea = []
    const convertedOrder = []

    employee.workArea.forEach((workArea, index) => {
      if (workArea === 'КТО' || workArea === 'ФВФ') {
        if (!convertedWorkArea.includes('КТО ФВФ')) {
          convertedWorkArea.push('КТО ФВФ')
          convertedOrder.push(employee.order[index])
        } else {
          const indexKTOFVF = convertedWorkArea.indexOf('КТО ФВФ')
          if (!convertedOrder[indexKTOFVF]) {
            convertedOrder[indexKTOFVF] = employee.order[index]
          }
        }
      } else {
        convertedWorkArea.push(workArea)
        convertedOrder.push(employee.order[index])
      }
    })

    if (employee.redirectedWorkArea && employee.redirectedWorkArea.length) {
      employee.redirectedWorkArea.forEach((workArea, index) => {
        if (workArea === 'КТО' || workArea === 'ФВФ') {
          if (!convertedWorkArea.includes('КТО ФВФ')) {
            convertedWorkArea.push('КТО ФВФ')
            convertedOrder.push(employee.order[employee.workArea.length + index])
          } else {
            const indexKTOFVF = convertedWorkArea.indexOf('КТО ФВФ')
            if (!convertedOrder[indexKTOFVF]) {
              convertedOrder[indexKTOFVF] = employee.order[employee.workArea.length + index]
            }
          }
        } else {
          convertedWorkArea.push(workArea)
          convertedOrder.push(employee.order[employee.workArea.length + index])
        }
      })
    }

    employee.convertedWorkArea = convertedWorkArea
    employee.convertedOrder = convertedOrder

    // Создание и наполнение employeesMap
    employee.convertedWorkArea.forEach((workArea, indexWorkArea) => {
      // Создаём orderInGroup - order в группе
      employee.orderInGroup = employee.convertedOrder[indexWorkArea]

      // Переведённый ли сотрудник в этой группе
      employee.redirected = true
      employee.workArea.forEach((employeeWorkArea) => {
        if (workArea.includes(employeeWorkArea)) {
          employee.redirected = false
        }
      })

      // Только направления из groupNameWorkAreas
      if (groupNameWorkAreas.includes(workArea)) {
        if (!employeesMap.has(workArea)) {
          employeesMap.set(workArea, {
            groups: {
              brigadeemployee: { employees: [], stat: getDefaultStat(workDays) },
              office: { employees: [], stat: getDefaultStat(workDays) },
              another: { employees: [], stat: getDefaultStat(workDays) }
            },
            stat: getDefaultStat(workDays)
          })
        }

        const group = employeesMap.get(workArea).groups[employee.role]
        const workAreaStat = employeesMap.get(workArea).stat

        group.employees.push(JSON.parse(JSON.stringify(employee)))

        // Обогащение статистикой
        if (!employee.redirected) {
          group.stat.common.workTime += employee.stat.workTime ? employee.stat.workTime : 0
          group.stat.common.driverHoursCount += employee.stat.driverHoursCount ? employee.stat.driverHoursCount : 0
          group.stat.common.totalReworkTime += employee.stat.totalReworkTime ? employee.stat.totalReworkTime : 0
          addEmployeeReworkTimeToCommonStat(employee.stat.reworkTime, group.stat.common.reworkTime)
          addEmployeeReworkTimeToCommonStat(employee.stat.additionalReworkTime, group.stat.common.additionalReworkTime)

          workAreaStat.common.workTime += employee.stat.workTime ? employee.stat.workTime : 0
          workAreaStat.common.driverHoursCount += employee.stat.driverHoursCount ? employee.stat.driverHoursCount : 0
          workAreaStat.common.totalReworkTime += employee.stat.totalReworkTime ? employee.stat.totalReworkTime : 0
          addEmployeeReworkTimeToCommonStat(employee.stat.reworkTime, workAreaStat.common.reworkTime)
          addEmployeeReworkTimeToCommonStat(employee.stat.additionalReworkTime, workAreaStat.common.additionalReworkTime)

          employee.schedule.forEach((day, indexDay) => {
            const isWorkingWorkShift = (day) => !(day.dayoff || day.vacation || day.compensatoryHoliday || day.suspended || day.notAllowed || day.mobilized || day.dismiss || day.absent && day.absent.length)
            const isWorkingDay = isWorkingWorkShift(day) || day.additionalWorkShifts && day.additionalWorkShifts.some(additionalWorkShift => isWorkingWorkShift(additionalWorkShift))

            if (isWorkingDay) {
              group.stat.days[indexDay]++
              workAreaStat.days[indexDay]++

              // Учитываем сотрудника только один раз в общей статистике
              if (!day._employeeCounted) {
                workDays[indexDay].employeesCount++
                day._employeeCounted = true
              }
            }
          })
        }
      }
    })
  })

  // Сортировка направлений работ по алфавиту
  employeesMap = new Map([...employeesMap.entries()].sort((a, b) => String(a[0]).localeCompare(b[0])))

  return employeesMap
}

export function convertEmployeesScheduleFromServer (employees, workDays) {
  for (let i = 0; i < employees.length; i++) {
    const employeeDefaultScedule = getDefaultScedule(workDays)

    for (let k = 0; k < employees[i].schedule.length; k++) {
      const decodedDay = decodeScheduleDayFields(employees[i].schedule[k])

      for (let j = 0; j < employeeDefaultScedule.length; j++) {
        if (employeeDefaultScedule[j].date === decodedDay.date) {
          employeeDefaultScedule[j] = decodedDay
        }
      }
    }
    employees[i].schedule = employeeDefaultScedule
  }

  return employees
}

function addEmployeeReworkTimeToCommonStat (employeeReworkTime, commonReworkTimeStat) {
  if (employeeReworkTime) {
    Object.keys(employeeReworkTime).forEach((id) => {
      if (!commonReworkTimeStat[id]) {
        commonReworkTimeStat[id] = employeeReworkTime[id]
      } else {
        commonReworkTimeStat[id] += employeeReworkTime[id]
      }
    })
  }
}

function getDefaultScedule (workDays) {
  const defaultScedule = []
  for (let i = 0; i < workDays.length; i++) {
    defaultScedule.push({
      date: workDays[i].date,
      dayoff: true,
      dayMatched: true
    })
  }
  return defaultScedule
}

function getDefaultStat (workDays) {
  const defaultStat = {
    common: {
      workTime: 0,
      driverHoursCount: 0,
      totalReworkTime: 0,
      reworkTime: {},
      additionalReworkTime: {}
    },
    days: []
  }
  for (let i = 0; i < workDays.length; i++) {
    defaultStat.days.push(0)
  }
  return defaultStat
}

export function decodeScheduleDayFields (encodedDay) {
  /*
    date => dt
    workShift => wsh
    absent => ab
    vacation => va, false on default
    mission => ms, false on default
    notAllowed  => na, false on default
    suspended => sp, false on default
    remote => rmt, false on default
    dayoff => dof, false on default
    compensatoryHoliday => ch
    autoAssignToBrigade => aab
    canPerformRequests => cpr, true on default
    isDepartureAllowed => ida, true on default
    isOfficeAllowed => ioa, true on default
    startHour => sh (может прийти значение даже если нерабочий день)
    endHour => eh (может прийти значение даже если нерабочий день)
    actualStartWorkTime => aswt
    actualEndWorkTime => aewt
    overtime => ot, 0 on default
    overtimeBefore => otb, 0 on default
    overtimeAfter => ota, 0 on default
    comment => cm
    brigade => b
    isBrigadeActive => iba, true on default
    overtimeTariffBeforeId => otab
    overtimeTariffAfterId => otaa
    overtimeTariffComment => otc
    dayOvertimeTariffs => dot, [] on default
    overtimeWorkShiftTariffId => owta
    additionalOvertimeTariffId => aota
    driverByDuration => dbd, false on default
    dismiss => d, false on default
    replacement => rpl, false on default
    workoff => wof, false on default
    rwa => redirectedWorkArea, [] on default
    planDayStatus => pls
    planDayHours => plh
    factDayStatus => fcs
    factDayHours => fch
    additionalWorkShifts => aws, [] on default
    dayMatched  => dayMatched, true on default

    Остальные поля: null on default
  */

  const decodedDay = {}
  decodedDay.id = encodedDay.id || null
  decodedDay.date = encodedDay.dt !== undefined ? date.extractDate(encodedDay.dt, 'YYYY-MM-DD').getTime() : null
  decodedDay.workShift = encodedDay.wsh !== undefined ? encodedDay.wsh : null
  decodedDay.absent = encodedDay.ab !== undefined ? encodedDay.ab : null
  decodedDay.vacation = encodedDay.va !== undefined ? encodedDay.va : false
  decodedDay.mission = encodedDay.ms !== undefined ? encodedDay.ms : false
  decodedDay.notAllowed = encodedDay.na !== undefined ? encodedDay.na : false
  decodedDay.suspended = encodedDay.sp !== undefined ? encodedDay.sp : false
  decodedDay.remote = encodedDay.rmt !== undefined ? encodedDay.rmt : false
  decodedDay.dayoff = encodedDay.dof !== undefined ? encodedDay.dof : false
  decodedDay.compensatoryHoliday = encodedDay.ch !== undefined ? encodedDay.ch : null
  decodedDay.autoAssignToBrigade = encodedDay.aab !== undefined ? encodedDay.aab : null
  decodedDay.canPerformRequests = encodedDay.cpr !== undefined ? encodedDay.cpr : true
  decodedDay.isDepartureAllowed = encodedDay.ida !== undefined ? encodedDay.ida : true
  decodedDay.isOfficeAllowed = encodedDay.ioa !== undefined ? encodedDay.ioa : true
  decodedDay.startHour = encodedDay.sh !== undefined && !decodedDay.dayoff ? encodedDay.sh : null
  decodedDay.endHour = encodedDay.eh !== undefined && !decodedDay.dayoff ? encodedDay.eh : null
  decodedDay.actualStartWorkTime = encodedDay.aswt !== undefined ? encodedDay.aswt : null
  decodedDay.actualEndWorkTime = encodedDay.aewt !== undefined ? encodedDay.aewt : null
  decodedDay.overtimeBefore = encodedDay.otb !== undefined ? encodedDay.otb : 0
  decodedDay.overtimeAfter = encodedDay.ota !== undefined ? encodedDay.ota : 0
  decodedDay.comment = encodedDay.cm !== undefined ? encodedDay.cm : null
  decodedDay.brigade = encodedDay.b !== undefined ? encodedDay.b : null
  decodedDay.isBrigadeActive = encodedDay.iba !== undefined ? encodedDay.iba : null
  decodedDay.overtimeTariffBeforeId = encodedDay.otab !== undefined ? encodedDay.otab : null
  decodedDay.overtimeTariffAfterId = encodedDay.otaa !== undefined ? encodedDay.otaa : null
  decodedDay.overtimeTariffComment = encodedDay.otc !== undefined ? encodedDay.otc : null
  decodedDay.overtimeWorkShiftTariffId = encodedDay.owta != null ? encodedDay.owta : null
  decodedDay.additionalOvertimeTariffId = encodedDay.aota != null ? encodedDay.aota : null
  decodedDay.overtimeWorkShift = encodedDay.owt != null ? encodedDay.owt : null
  decodedDay.driverByDuration = encodedDay.dbd !== undefined ? encodedDay.dbd : false
  decodedDay.dismiss = encodedDay.d !== undefined ? encodedDay.d : false
  decodedDay.replacement = encodedDay.rpl !== undefined ? encodedDay.rpl : false
  decodedDay.workoff = encodedDay.wof !== undefined ? encodedDay.wof : false
  decodedDay.redirectedWorkArea = encodedDay.rwa !== undefined ? encodedDay.rwa : []
  decodedDay.planDayStatus = encodedDay.pls !== undefined ? encodedDay.pls : null
  decodedDay.planDayHours = encodedDay.plh !== undefined ? encodedDay.plh : null
  decodedDay.factDayStatus = encodedDay.fcs !== undefined ? encodedDay.fcs : null
  decodedDay.factDayHours = encodedDay.fch !== undefined ? encodedDay.fch : null
  decodedDay.additionalWorkShifts = encodedDay.aws !== undefined ? encodedDay.aws : []
  decodedDay.dayMatched = encodedDay.dayMatched !== undefined ? encodedDay.dayMatched : true
  decodedDay.mobilized = encodedDay.mo !== undefined ? encodedDay.mo : false
  decodedDay.projects = encodedDay.prj !== undefined ? encodedDay.prj : null

  if (decodedDay.additionalWorkShifts.length) {
    decodedDay.additionalWorkShifts.forEach((day, index) => {
      decodedDay.additionalWorkShifts[index] = decodeScheduleDayFields(day)
    })
  }

  return decodedDay
}
